/**
 * Founding Beta — Athlete Pass is granted automatically to all users (new + legacy).
 * This component is now a transparent passthrough that preserves the API surface
 * for the rest of the app, so we don't have to ripple-edit every route.
 *
 * When the Founding Beta ends, replace this with a real gate.
 */
const RequireAthletePass = ({ children }) => children;

export default RequireAthletePass;
